(function () {

    'use strict';

    angular.module('filter')
        .directive('filter', ['FilterService', 'filterConfigService', 'DataService', 'dataConfigService', function (FilterService, filterConfigService, DataService, dataConfigService) {
            return {
                templateUrl: 'layout/filter/filterElement.html',
                link: function (scope) {
                    scope.regions = _.orderBy(DataService.getRegions(), 'pavadinimas');
                    scope.services = _.orderBy(DataService.getRoadServices(), 'pavadinimas');
                    scope.masteries = _.orderBy(DataService.getMasteries(), 'pavadinimas');
                    scope.violations = _.orderBy(DataService.getViolations(), 'pavadinimas');
                    scope.statuses = _.orderBy(DataService.getStatus(), 'pavadinimas');
                    scope.workTypes = _.orderBy(DataService.getWorkTypes(), 'pavadinimas');

                    FilterService.currentFilters = angular.copy(FilterService.filters);
                    scope.filters = FilterService.currentFilters;
                    scope.dataConfig = dataConfigService.config;

                    scope.roadAutocompleteUrl = filterConfigService.roadAutocompleteURL;
                    scope.userAutocompleteUrl = filterConfigService.userAutocompleteURL;

                    scope.remove = function (index) {
                        scope.filters.splice(index, 1);
                    };

                    scope.parameterSelected = function (item, index) {
                        item.parameterConfig = getParameterConfigByParameter(item.parameter);
                        item.type = item.parameterConfig.type;
                        if (item.parameterConfig.operands.indexOf(item.operand) === -1) {
                            item.operand = item.parameterConfig.operands[0];
                        }
                        item.value = null;
                        item.roadName = null;
                        scope.$broadcast('angucomplete-alt:clearInput', 'road' + index);
                    };

                    //angucomplete onselect
                    scope.selectRoad = function (selectedItem) {
                        if (selectedItem) {
                            scope.filters[scope.focusedIndex].value = selectedItem.originalObject.id;
                            //save name for repeated angucomplete initialisation
                            scope.filters[scope.focusedIndex].roadName = selectedItem.originalObject.numeris + ' ' + selectedItem.originalObject.pavadinimas;
                        }
                    };

                    //angucomplete onselect
                    scope.selectUser = function (selectedItem) {
                        if (selectedItem) {
                            scope.filters[scope.focusedIndex].value = selectedItem.originalObject.id;
                            //save name for repeated angucomplete initialisation
                            scope.filters[scope.focusedIndex].fullName = selectedItem.originalObject.name + ' ' + selectedItem.originalObject.surname;
                        }
                    };

                    //angucomplete onfocus
                    scope.focusIn = function (index) {
                        scope.focusedIndex = index;
                    };

                    function getParameterConfigByParameter(parameter) {
                        var returnValue;
                        angular.forEach(scope.dataConfig, function (item) {
                            if (item.parameter === parameter) {
                                returnValue = item;
                            }
                        });
                        return returnValue;
                    }
                }
            };
        }]);
})();
